import styled from 'styled-components';
import { BasketUserDetailsStyled } from '../BasketUserDetailsStyled';
import { rem } from 'polished';

export const BasketUserDetailsAP = styled(BasketUserDetailsStyled)``;
